import {Component, HostListener, ViewChild} from '@angular/core'
import {ActivatedRoute} from '@angular/router'
import {DynamicCategoryLandingPageResolved} from './category-landing-page.resolver'
import {OptableLayout} from '../../../core/components/layout/optable-layout.interface'
import {PageComponent, PageMetadata} from '../../../core/seo/page-metadata'
import {Observable} from 'rxjs'
import {LinkService} from '../../../core/i18n/link.service'
import {map} from 'rxjs/operators'
import {DocumentService} from '../../../craft/utils/document.service'
import {CategoryLandingPageContentComponent} from './category-landing-page-content/category-landing-page-content.component'
import {PUBLIC_ROUTES} from '../../../shared/routing/public.routes'
import {Language} from '../../../core/i18n/language'
import {ApplicationRoute} from '../../../craft/utils/application.route'

@Component({
  templateUrl: './category-landing-page.component.html',
  standalone: false,
})
export class CategoryLandingPageComponent extends PageComponent implements OptableLayout {
  readonly page$: Observable<DynamicCategoryLandingPageResolved>
  readonly optOutOfLayout = true

  showStickyFooter = false

  @ViewChild('contentSection') private readonly contentSection!: CategoryLandingPageContentComponent

  @HostListener('window:scroll', ['$event'])
  onScroll(event) {
    this.showStickyFooter = event.target?.defaultView?.scrollY > 400
  }

  constructor(
    private readonly route: ActivatedRoute,
    private readonly linkService: LinkService,
    private readonly documentService: DocumentService,
  ) {
    super()
    this.page$ = this.route.data.pipe(map(data => data['content']))
  }

  getPageMetadata(): Observable<PageMetadata> {
    return this.page$.pipe(
      map(page => ({
        twitterCard: 'summary_with_large_image',
        title: page.content.title,
        description: page.content.description,
        imageUrl: page.content.bannerImage.url,
        doNotIndexPage: page.content.meta ? page.content.meta.doNotIndex : false,
        canonicalUrl: page.content.meta?.canonicalUrl,
      })),
    )
  }

  protected getOfferingId(page: DynamicCategoryLandingPageResolved): string | undefined {
    const path = page.content.primaryCallToAction?.value

    if (path instanceof ApplicationRoute && path.path.startsWith(':locale/offerings')) {
      return path.path.split('/')[2]
    }
  }

  // This method is purely used to handle click events form child sections
  handleMainActionClick(page: DynamicCategoryLandingPageResolved): void {
    if (page.content.primaryCallToAction?.value instanceof ApplicationRoute) {
      this.linkService.navigateTo(page.content.primaryCallToAction.value)
      return
    }

    if (this.contentSection.offeringSection?.nativeElement) {
      this.documentService.scrollToElement(this.contentSection.offeringSection.nativeElement, {topOffset: -100})
      return
    }

    this.linkService.navigateTo(PUBLIC_ROUTES.PRO_DIRECTORY_PAGE)
  }

  getPageAvailableLanguages(): Observable<Language[] | undefined> {
    return this.page$.pipe(map(p => p.content.meta?.availableLanguages))
  }
}
